import {
  NOTIFICATIONS_TABLE_SORT_ENABLED,
  NOTIFICATIONS_TABLE_SORT_DISABLED,
} from '../actions/notifications_table_sort'

export const notificationsSort = (state = { sortField: null, order: null }, action) => {
  switch (action.type) {
    case NOTIFICATIONS_TABLE_SORT_ENABLED:
      return { ...state, sortField: action.sortField, order: action.order }
    case NOTIFICATIONS_TABLE_SORT_DISABLED:
      return { ...state, sortField: null, order: null }
    default:
      return state
  }
}
